/* eslint-disable eqeqeq */
import React, { useEffect, useState } from 'react';
import {
    Typography,
    Divider,
    Button,
    Input,
    Row,
    Col,
    InputNumber,
} from 'antd';
import { useCouter } from '../../../hooks/useCouter';
import { formatMoney } from '../../../utils/general';
import { getCompanyIdApi } from '../../../api/company';
import food from '../../../assets/img/jpg/seafood.jpg';
import userOrder from '../../../hooks/useOrder';
import Secciones from './Secciones';

import './DescriptionItem.scss';

const DescriptionItem = (props) => {
    const { item, setIsModalVisible } = props;
    // const { item, setIsModalVisible, setCounterItem, setTotalOrder, totalOrder } = props;
    const { name, description, itemId, itemImage, price, itemSections } = item;
    const { Title, Paragraph } = Typography;
    const { TextArea } = Input;
    let { state, decrement, increment, setState } = useCouter(1);
    const [total, setTotal] = useState(0);
    const [instructions, setInstructions] = useState('');
    const [typeQuantity, setTypeQuantity] = useState(0);
    const [priceQuantity, setPriceQuantity] = useState(
        item.unitOfMeasure ? item.unitOfMeasure.minimumPurchase : 0
    );
    const [totalFinal, setTotalFinal] = useState(0);

    // const [valueCheck, setValueCheck] = useState(2);
    let quantityMax;
    let quantityMin;
    // const onChangeCheck = (e) => {
    //     setValueCheck(e.target.value);
    // };

    const companyId = getCompanyIdApi();
    const { orderGeneral, setOrderGeneral } = userOrder();
    const [extraPrice, setExtraPrice] = useState(0.0);
    const [optionTable, setOptionTable] = useState([]);
    const { Subtotal } = orderGeneral;

    const filtradas = itemSections.filter((ele) => ele.available);
    let nameUnitOfMeasure;

    if (item.unitOfMeasure !== null) {
        switch (item.unitOfMeasure.unitType) {
            case 0:
                nameUnitOfMeasure = '';
                break;
            case 1:
                nameUnitOfMeasure = 'Kg';
                break;
            case 2:
                nameUnitOfMeasure = 'gr';
                break;
            case 3:
                nameUnitOfMeasure = 'Lt';
                break;
            case 4:
                nameUnitOfMeasure = 'ml';
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        const found = orderGeneral.orderLinesList.find(
            (element) => element.itemId === itemId
        );
        if (found !== undefined && found !== null) {
            setInstructions(found.instructions);
            if (item.itemSections.length > 0 || item.unitOfMeasure) {
                setState(1);
            } else {
                setState(found.quantity);
            }
        } else {
            setInstructions('');
        }
        setTotal(0);
        return () => {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (item.unitOfMeasure !== null) {
            setTotalFinal(
                total + (parseFloat(priceQuantity) + extraPrice) * state
            );
        } else {
            setTotalFinal(total + (extraPrice + price) * state);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [extraPrice, price, state, priceQuantity, total]);

    const onChange = ({ target: { value } }) => {
        setInstructions(value);
    };
    const onChangeQuantity = (quantity) => {
        if (isNaN(quantity) === false) {
            const quantityNum = parseFloat(quantity) || 0;

            setTypeQuantity(quantityNum > 0 ? quantityNum : 0);
            setPriceQuantity(
                quantityNum > 0 ? parseFloat(quantityNum * price).toFixed(2) : 0
            );
        }
    };
    const onChangePrice = (priceUoms) => {
        if (isNaN(priceUoms) === false) {
            if (priceUoms === null) {
                priceUoms = parseFloat(item.unitOfMeasure.minimumPurchase);
                setPriceQuantity(priceUoms);
            }
            setPriceQuantity(priceUoms);
            let cantidad = parseFloat(priceUoms / price).toFixed(3);
            setTypeQuantity(cantidad);
        }
    };

    const add = () => {
        const found = orderGeneral.orderLinesList.findIndex(
            (item) => item.itemId === itemId
        );

        if (found === -1) {
            //Es un platillo nuevo

            function uuidv4() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
                    /[xy]/g,
                    function (c) {
                        // eslint-disable-next-line eqeqeq
                        // eslint-disable-next-line no-mixed-operators
                        var r = (Math.random() * 16) | 0,
                            v = c == 'x' ? r : (r & 0x3) | 0x8;
                        return v.toString(16);
                    }
                );
            }

            let result = {
                extraPrice,
                name: name,
                price: price,
                priceUoms: priceQuantity,
                measurementUnits: typeQuantity ? typeQuantity : quantityMin,
                typeUoms: nameUnitOfMeasure,
                altPrice: totalFinal,
                instructions: instructions,
                quantity: state,
                companyId: companyId,
                itemId: itemId,
                itemIdUnique: `${uuidv4()}`,
                options: optionTable,
            };

            orderGeneral.orderLinesList.push(result);
            // setOrder(order);

            // setCounterItem(orderGeneral.orderLinesList.length);
            let total = Subtotal + totalFinal;
            // let total = totalOrder;

            // total = totalFinal ;

            // setTotalOrder(total);
            setOrderGeneral({
                ...orderGeneral,
                Subtotal: total,
            }); //nuevo hook
            setIsModalVisible(false);
        } else {
            //ya estaba
            if (item.itemSections.length > 0 || item.unitOfMeasure) {
                //se agregara como nuevo

                function uuidv4() {
                    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
                        /[xy]/g,
                        function (c) {
                            // eslint-disable-next-line eqeqeq
                            // eslint-disable-next-line no-mixed-operators
                            var r = (Math.random() * 16) | 0,
                                v = c == 'x' ? r : (r & 0x3) | 0x8;
                            return v.toString(16);
                        }
                    );
                }
                let result = {
                    extraPrice,
                    name: name,
                    price: price,
                    priceUoms: priceQuantity,
                    measurementUnits: typeQuantity ? typeQuantity : quantityMin,
                    typeUoms: nameUnitOfMeasure,
                    altPrice: totalFinal,
                    instructions: instructions,
                    quantity: state,
                    companyId: companyId,
                    itemId: `${itemId}/${uuidv4()}`,
                    itemIdUnique: `${uuidv4()}`,
                    options: optionTable,
                };

                orderGeneral.orderLinesList.push(result);
                // setOrder(order);

                // setCounterItem(orderGeneral.orderLinesList.length);

                let total = Subtotal + totalFinal;
                // let total = totalOrder;

                // total = totalFinal;
                // setTotalOrder(total);
                setOrderGeneral({ ...orderGeneral, Subtotal: total }); //nuevo hook
                setIsModalVisible(false);
            } else {
                //Ya estaba en la cesta
                orderGeneral.orderLinesList[found].quantity = state;
                orderGeneral.orderLinesList[found].instructions = instructions;
                let suma = 0;

                orderGeneral.orderLinesList.forEach((element) => {
                    suma =
                        suma +
                        (element.extraPrice + element.price) * element.quantity;
                });
                setOrderGeneral({ ...orderGeneral, Subtotal: suma });
                setIsModalVisible(false);
            }
        }
    };
    const onSectionOptionsChanged = (table) => {
        let tmp = 0.0;
        let options = [];
        for (const [key, value] of Object.entries(table)) {
            let seccOriginal = itemSections.find((e) => e.itemSectionId == key);
            if (seccOriginal && seccOriginal.sectionOptions.length > 0) {
                if (value && value.length > 0) {
                    // eslint-disable-next-line no-loop-func
                    value.forEach((v) => {
                        const opt = {
                            ...seccOriginal.sectionOptions[v],
                            id: seccOriginal.itemSectionId,
                            nameSection: seccOriginal.name,
                        };
                        tmp = tmp + opt.price;
                        options.push(opt);
                    });
                }
            }
        }
        setOptionTable(options);
        setExtraPrice(parseFloat(tmp));
    };

    const obligatorySections = [];
    itemSections
        .filter((item) => item.obligatory && item.available)
        .forEach((item) =>
            item.sectionOptions.forEach((s) => {
                if (!obligatorySections.includes(s.itemSectionId))
                    obligatorySections.push(s.itemSectionId);
            })
        );
    const selectedObligatorySections = [];
    optionTable.forEach((opt) => {
        const original = itemSections.find(
            (sec) => sec.itemSectionId === opt.itemSectionId
        );

        if (
            original.obligatory &&
            !selectedObligatorySections.includes(opt.itemSectionId)
        )
            selectedObligatorySections.push(opt.itemSectionId);
    });
    const notAllSelected =
        obligatorySections.sort().toString() !=
        selectedObligatorySections.sort().toString();
    let invalidUom = false;

    if (item.unitOfMeasure) {
        quantityMax = parseFloat(
            item.unitOfMeasure.maximumPurchase / item.price
        ).toFixed(3);
        quantityMin = parseFloat(
            item.unitOfMeasure.minimumPurchase / item.price
        ).toFixed(3);
        invalidUom =
            priceQuantity < item.unitOfMeasure.minimumPurchase ||
            priceQuantity > item.unitOfMeasure.maximumPurchase;
    }
    return (
        <div className="description-item">
            <div className="description-item__container-image">
                {itemImage !== null && (
                    <img
                        src={
                            itemImage !== null
                                ? `data:image/${itemImage.extension};base64, ${itemImage.imageData}`
                                : food
                        }
                        alt="Italian Trulli"
                    ></img>
                )}
            </div>
            <div className="description-item__container">
                <Title level={3}>{name}</Title>
                <Title level={5}>
                    ${formatMoney(price)} {nameUnitOfMeasure}
                </Title>
                <p>{description}</p>
            </div>

            {item.unitOfMeasure !== null && (
                <div>
                    <Divider>Unidad de medida</Divider>
                    <Row className="justify-items-uoms">
                        <Col>
                            <p>Seleccionar unidad de medida:</p>
                        </Col>
                    </Row>
                    {/* <Radio.Group onChange={onChangeCheck} value={valueCheck}>
                        <Radio value={2}>Cantidad</Radio>
                        <Radio value={1}>Precio</Radio>
                    </Radio.Group> */}

                    <Row className="justify-items-uoms">
                        <Col xs={24} lg={24}>
                            {/* {valueCheck === 2 && ( */}
                            <p>Cantidad: </p>
                            <Row>
                                <Col xs={12} lg={12}>
                                    <InputNumber
                                        maxLength={7}
                                        min={quantityMin}
                                        max={quantityMax}
                                        style={{
                                            width: '100%',
                                        }}
                                        formatter={(value) =>
                                            ` ${value}`.replace(
                                                /\B(?=(\d{3})+(?!\d))/g,
                                                ','
                                            )
                                        }
                                        parser={(value) =>
                                            value.replace(/\$\s?|(,*)/g, '')
                                        }
                                        placeholder="2"
                                        value={typeQuantity}
                                        onChange={(value) =>
                                            onChangeQuantity(value)
                                        }
                                    />
                                </Col>
                                {/* <Col xs={12} lg={12}> */}
                                <p className="margin-left">
                                    {' '}
                                    {nameUnitOfMeasure}
                                    {' = $'}
                                    {formatMoney(priceQuantity)}
                                </p>
                                {/* </Col> */}
                            </Row>
                            {/* )} */}
                            {/* {valueCheck === 1 && ( */}
                            <p>Precio:</p>

                            <Row>
                                <Col xs={12} lg={12}>
                                    <InputNumber
                                        precision={2}
                                        maxLength={9}
                                        min={item.unitOfMeasure.minimumPurchase}
                                        max={item.unitOfMeasure.maximumPurchase}
                                        style={{
                                            width: '100%',
                                        }}
                                        formatter={(value) =>
                                            `$ ${value}`.replace(
                                                /\B(?=(\d{3})+(?!\d))/g,
                                                ','
                                            )
                                        }
                                        parser={(value) =>
                                            value.replace(/\$\s?|(,*)/g, '')
                                        }
                                        placeholder="2"
                                        value={priceQuantity}
                                        onChange={(value) =>
                                            onChangePrice(value)
                                        }
                                    />
                                </Col>
                                {/* <Col xs={12} lg={12}> */}
                                {/* {typeQuantity && typeQuantity !== 0 && ( */}
                                <p className="margin-left">
                                    {' '}
                                    {typeQuantity
                                        ? typeQuantity
                                        : quantityMin}{' '}
                                    {nameUnitOfMeasure}
                                </p>
                                {/* )} */}
                                {/* </Col> */}
                            </Row>
                            {/* )} */}
                        </Col>
                    </Row>
                    <Col>
                        <p>
                            Máximo $
                            {formatMoney(item.unitOfMeasure.maximumPurchase)}
                        </p>
                        <p>
                            Mínimo $
                            {formatMoney(item.unitOfMeasure.minimumPurchase)}
                        </p>
                    </Col>
                    {/* {((priceQuantity && priceQuantity !== 0) || (typeQuantity !== 0)) && (
                        <>
                            <p>Total de {name}: ${formatMoney(priceQuantity)}</p>
                            <p>CANTIDAD: {typeQuantity} {nameUnitOfMeasure}</p>
                        </>
                    )
                    } */}
                </div>
            )}
            {itemSections.length >= 1 && filtradas.length >= 1 && (
                <>
                    <Divider>Ingredientes</Divider>
                </>
            )}

            <Secciones
                itemSections={itemSections}
                onChange={onSectionOptionsChanged}
            />
            <Divider>Instrucciones Especiales</Divider>
            <TextArea
                value={instructions}
                placeholder="Instrucciones Especiales"
                autoSize={{ minRows: 2, maxRows: 6 }}
                onChange={onChange}
            />
            <div className="description-item__container">
                <Divider>Cantidad</Divider>
                <Row className="counter">
                    <Col span={8}>
                        <Button
                            disabled={state === 1}
                            onClick={decrement}
                            danger
                        >
                            -
                        </Button>
                    </Col>
                    <Col span={8}>{state}</Col>
                    <Col span={8}>
                        <Button onClick={increment} danger>
                            +
                        </Button>
                    </Col>
                </Row>
                {item.unitOfMeasure !== null &&
                    priceQuantity !== 0 &&
                    priceQuantity !== null && (
                        <>
                            <Divider></Divider>
                            <Paragraph className="right">
                                {typeQuantity ? typeQuantity : quantityMin}
                                {nameUnitOfMeasure} {name}: $
                                {formatMoney(priceQuantity)}
                                <br />
                                Extras: ${formatMoney(extraPrice)}
                            </Paragraph>
                        </>
                    )}
                <Divider></Divider>

                <Paragraph className="right">
                    {/* Total: ${item.unitOfMeasure ? formatMoney(priceQuantity) : formatMoney(totalFinal) } */}
                    Total: ${formatMoney(totalFinal)}
                </Paragraph>
            </div>
            <Button
                type="primary"
                danger
                block
                onClick={add}
                disabled={notAllSelected || invalidUom}
            >
                Agregar {state}
            </Button>
        </div>
    );
};

export default DescriptionItem;
